$(document).on('turbo:load', function() {
  if (typeof(gtag) === "function") {
    gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href
    });
  }
})
